import { render, staticRenderFns } from "./PkgRiskSubItemList.vue?vue&type=template&id=76ba78d0&"
import script from "./PkgRiskSubItemList.vue?vue&type=script&lang=js&"
export * from "./PkgRiskSubItemList.vue?vue&type=script&lang=js&"
import style0 from "./PkgRiskSubItemList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgRiskSubItemList.vue"
export default component.exports